import { type ReactNode } from 'react';
import Popover, { type PopoverPlacement } from '@creditflowresearch/uilib/Popover';
import Flex from '@creditflowresearch/uilib/Flex';
import Button from '@creditflowresearch/uilib/Button';

import styles from './bondScreenerDeleteViewModal.module.scss';

interface IBondScreenerDeleteViewModalProps {
  isVisible: boolean,
  onVisibleChange: (isVisible: boolean) => void,
  onConfirm: () => void,
  dataTest: string,
  placement?: PopoverPlacement,
  disabled?: boolean,
  children: ReactNode,
}

const BondScreenerDeleteViewModal = ({
  isVisible,
  onVisibleChange,
  onConfirm,
  dataTest,
  placement = 'top-end',
  disabled = false,
  children,
}: IBondScreenerDeleteViewModalProps) => (
  <Popover
    isVisible={ isVisible }
    setIsVisible={ onVisibleChange }
    placement={ placement }
    dataTest={ dataTest }
    disabled={ disabled }
    contentClassName={ styles.content }
    content={ (
      <div className={ styles.body }>
        <p className={ styles.title }>Are you sure?</p>
        <p className={ styles.description }>
          Are you sure you want to delete this view? Any changes made will be lost.
        </p>
        <Flex gap={ 30 } align="center">
          <Button
            variant="solid"
            color="error"
            size="M"
            onClick={ onConfirm }
            dataTest={ `${ dataTest }Confirm` }
          >
            Delete
          </Button>
          <Button
            variant="text"
            size="M"
            onClick={ () => onVisibleChange(false) }
            dataTest={ `${ dataTest }Cancel` }
          >
            Cancel
          </Button>
        </Flex>
      </div>
    ) }
  >
    { children }
  </Popover>
);

export default BondScreenerDeleteViewModal;
